import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `,
    "ContentDiv": styled.div`
        width: fit-content;
        height: fit-content;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 80px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 20px;
        padding: 96px 64px;

        & > h2 {
            ${({ theme }) => theme.font.large_bold}
        }
    `,
    "FormDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 32px;
        width: 432px;
        background-color: ${({ theme }) => theme.color.white};
    `,
    "BtnDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: end;
        gap: 12px;
    `,

    "IdResult": styled.p`
        width: 100%;
        text-align: center;
        ${({ theme }) => theme.font.small};
        border-top: 1px solid ${({ theme }) => theme.color.grey2};
        border-bottom: 1px solid ${({ theme }) => theme.color.grey2};
        padding: 16px 0;

        & > span {
            ${({ theme }) => theme.font.small_bold};
            color: ${({ theme }) => theme.color.grey3};
        }
    `,
    "Guide": styled.p`
        ${({ theme }) => theme.font.small};
        color: ${({ theme }) => theme.color.grey3};
        margin-top: 12px;
    `,
}